import { ref } from 'vue'
import { api } from '@/api'
import { getDeviceFeature } from '@/utils/deviceFeature'
import { isUCBrowser } from '@/utils/bowserEnv'
import { brand } from '@/config/brands'
import { isTalewaveAppHost } from '@/config/brands/clientGroup'

export const bannerShow = ref(false)

/**
 * 是否通过达人分享进入
 * 标识在 useAttribution 中收集归因信息时持久化
 */
function isTalentShare() {
  return localStorage.getItem('IS_TALENT_SHARE') === '1'
}

export function useBannerShow() {
  if (bannerShow.value || isUCBrowser() || isTalentShare())
    return

  if (brand === 'rocnovel') {
    const matchLayer = api.post(`/member/layer/match?layerConfigIdStr=${import.meta.env.VITE_BIZ_SHOWBANNER_LAYER_ID}`)
    const matchAd = api.get('/member/ad/info')

    Promise.all([matchLayer, matchAd]).then((res) => {
      bannerShow.value = !!res[0].data && !!res[1].data?.displayDirectToApp
    })
  }
  // talewave 仅 APP 组别域名启用，以落地页标注 displayDirectToApp 为准，不走人群层匹配
  else if (isTalewaveAppHost()) {
    api.get('/member/ad/info').then((res) => {
      bannerShow.value = !!res.data?.displayDirectToApp
    })
  }
}

/**
 * 唤端中转页地址，talewave 复用 w2a 同款官网下载中转页
 * download.html 部署在官网服务上，SPA 域名下无此文件，不能用同源路径
 * 环境划分与 w2a getOrigin 一致：仅测试环境走 www-test，pre/生产走 www
 */
function getAppCallUrl(target: string) {
  if (brand === 'talewave') {
    const origin = ['development', 'testing'].includes(import.meta.env.MODE)
      ? 'https://www-test.talewave.net'
      : 'https://www.talewave.net'
    return `${origin}/app/download.html?target=${encodeURIComponent(target)}`
  }
  return `https://h5.rocnovel.com/rocnovel/app?target=${encodeURIComponent(target)}#/rocnovel/app`
}

export function useCallApp() {
  async function callApp(id?: string, index?: number) {
    const deviceFeature = await getDeviceFeature()
    const token = localStorage.getItem('TOKEN')
    let target
    let copyStr

    if (id && index) {
      target = `/read?id=${id}&index=${Number(index) - 1}`
      copyStr = `#${brand}#${token}#${target}`
    }
    else if (id) {
      target = `/book_detail?id=${id}`
      copyStr = `#${brand}#${token}#${target}`
    }
    else {
      target = ''
      copyStr = `#${brand}#${token}`
    }

    try {
      navigator.clipboard.writeText(copyStr).then(async () => {
        await api.post('/member/deviceFeature', { deviceFeature })
        // eslint-disable-next-line no-console
        console.info('target', target)
        // eslint-disable-next-line no-console
        console.info('copyStr', copyStr)
        window.location.href = getAppCallUrl(target)
      })
    }
    catch (err) {
      console.error('复制失败:', err)
      window.location.href = getAppCallUrl(target)
    }
  }

  return {
    callApp,
  }
}
